<template>
  <div>
    <div v-html="cssContent" class="css-content" />
    <div
      :class="[
        'html-content',
        { 'mystage-view-ipad': isIpadDevice },
        { 'mystage-view-pc': !isMobileWidth && !isIpadDevice },
        { 'cms-safari': isSafariBrowser }
      ]"
      :style="zoomPdfHtmlMaterial"
      v-dompurify-html="htmlBody"
      ref="htmlContainer"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import VocabularyTooltip from '@/mixins/vocabularyTooltip';
import materialMixin from '@/mixins/material';
import cmsPreview from '@/mixins/cmsPreview';

export default {
  mixins: [VocabularyTooltip, materialMixin, cmsPreview],
  props: {
    isMobileWidth: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      isLoading: false,
      cmsAudio: null,
      cmsTableScrolls: []
    };
  },
  mounted() {
    if (this.htmlBody) {
      this.updateHtmlContent();
    }
  },
  watch: {
    htmlBody() {
      this.$nextTick(() => {
        this.updateHtmlContent();
      });
      // After cms material rendered, wait 1 seconds before adding touch event in the audio
      setTimeout(() => {
        this.setCmsAudioTouchEvent();
      }, 2000);
    },
    isMobileWidth() {
      this.setMaterialFontSize();
    },
  },
  computed: {
    ...mapState('material', ['pdfHtmlZoom', 'isLevel0']),
    ...mapState('layout', ['isMaterialFullScreen']),
    ...mapState('htmlMaterial', [
      'htmlCss',
      'htmlBody',
      'htmlLevel',
      'htmlLessonId',
      'htmlRank',
      'htmlIsRevamp'
    ]),
    ...mapState('layout', ['isIpadDevice']),
    ...mapGetters(['isStudent', 'isDiscoveryLesson', 'nonActualLesson', 'isCorpLesson']),

    cssContent() {
      return `<style type="text/css">${this.htmlCss}</style>`;
    },

    zoomIcon() {
      const icon = this.isMaterialFullScreen ? 'text_zoomout_sp@2x.png' : 'text_zoom_sp@2x.png';
      return require(`@/assets/img/${icon}`);
    }
  },
  methods: {
    ...mapMutations('layout', ['materialFullScreen']),

    fullScreenMaterial() {
      this.materialFullScreen();
    },

    setMaterialFontSize() {
      if (this.isDiscoveryLesson || !this.isIpadDevice || this.htmlIsRevamp) {
        return;
      }

      const htmlContent = document.querySelectorAll('.html-content')[0];
      const elementsToAdjust =
        `header, section, aside, aside .sub-text, aside .text, .section,` +
        `.title, .ja, .arrow-part p, .eng, .jap, table`;
      let children = htmlContent.querySelectorAll(elementsToAdjust);
      for (let item of children) {
        const initialFontSize = window.getComputedStyle(item).fontSize;
        item.style.fontSize = this.isMobileWidth
          ? ''
          : parseInt(initialFontSize) * 0.74 + 'px';
      }
    },

    setMaterialLevel() {
      const htmlMaterial = document.querySelector('.html-lesson-wrapper');
      if (htmlMaterial) {
        htmlMaterial.classList.add(`level-${this.htmlLevel}`);
        htmlMaterial.classList.add(`rank-${this.htmlRank.slice(-1)}`);
        htmlMaterial.classList.add(`lesson-${this.htmlLessonId}`);
      }
    },

    async updateHtmlContent() {
      if (this.nonActualLesson) {
        this.setMaterialLevel();
        this.setTablePerfectScroll();
        this.$emit('htmlLoaded', true);
        return;
      }
      // pass the html element as html collection|html string
      if (this.htmlBody) {
        this.$emit('htmlLoaded', false);
        await this.initializedTooltip(this.htmlBody, false);
        if (!this.isMobileWidth) {
          setTimeout(() => this.setMaterialFontSize(), 100);
        }
        this.setMaterialLevel();
        this.setTablePerfectScroll();
        setTimeout(() => this.$emit('htmlLoaded', true), 400);
      }
    },
    setCmsAudioTouchEvent() {
      this.cmsAudio = document.getElementsByClassName('audio-content');
      if (this.cmsAudio) {
        for (let cmsAudioElement of this.cmsAudio) {
          cmsAudioElement.addEventListener('touchmove', this.removeScrollPropagation, { passive: false });
          cmsAudioElement.addEventListener('touchstart', this.removeScrollPropagation, { passive: false });
        }
      }
    },
    removeScrollPropagation(e) {
      e.stopImmediatePropagation();
    },
  },
  beforeDestroy() {
    if (this.cmsAudio) {
      for (let cmsAudioElement of this.cmsAudio) {
        cmsAudioElement.removeEventListener('touchmove', this.removeScrollPropagation, { passive: false });
        cmsAudioElement.removeEventListener('touchstart', this.removeScrollPropagation, { passive: false });
      }
    }
    if (this.cmsTableScrolls.length) {
      this.cmsTableScrolls.forEach((cmsTableScrolls) => {
        cmsTableScrolls.destroy();
      });
    }
  }
};
</script>

<style scoped src="@/assets/css/pc/vocabulary_tooltip.css"></style>
<style scoped src="@/assets/css/pc/pdf_material.css"></style>
<style src="@/assets/css/pc/pdf_html.css"></style>
